import _ from "lodash";
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import "./EventSliderFilter.scss";
import { providerList } from "../../../redux/provider/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function EventSliderFilterSection({ selectedPartner, setSelectedPartner }) {
  const [providersData, setprovidersData] = useState([]);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  const [isProviderLoaded, setIsProviderLoaded] = useState(true);
  const providersDataResponse = useSelector(
    (state) => state.provider.providersDataListRes
  );
  useEffect(() => {
    if (!_.isEmpty(providersDataResponse)) {
      if (providersDataResponse.status === "success") {
        setprovidersData(providersDataResponse.payload.payload?.list);
        setIsProviderLoaded(false);
      } else {
        setprovidersData();
        setIsProviderLoaded(false);
      }
    }
  }, [providersDataResponse]);

  const provider_list = () => {
    setIsProviderLoaded(true);
    dispatch(
      providerList({
        module: "providerList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          sort_by: "ASC",
          is_coaching: true,
          entity_type:
            tab === "1"
              ? "Courses"
              : tab === "2"
              ? "Videos"
              : tab === "3"
              ? "Event"
              : tab === "4"
              ? "Certificate"
              : tab === "5" || window.location.pathname.includes("coaching")
              ? "Coaching"
              : tab === "6"
              ? "learningpath"
              : "",
        },
      })
    );
  };

  useEffect(() => {
    provider_list();
  }, []);

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // const {providersData } = props;
  const [selectedPartnerName, setSelectedPartnerName] = useState("");

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z"
            fill="white"
          />
        </svg>
      </div>
    );
  }
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M10 6L16 12L10 18L8.6 16.6L13.2 12L8.6 7.4L10 6Z"
            fill="white"
          />
        </svg>
      </div>
    );
  }

  const setSelectedPartnerDetails = (item) => {
    setSelectedPartner(item === "all" ? "all" : item?.provider_id);
    setSelectedPartnerName(item?.display_name);
  };

  const detailPage = () => {
    let paramsReq = {
      provider_id: selectedPartner,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/partner-detail/?c=${encodedUrl}`;
    navigate(url);
  };

  return (
    <>
      <div className="slider-filter-events d-flex">
        {_.isArray(providersData) && providersData.length > 0 ? (
          <div
            className={
              selectedPartner === "all"
                ? "all-filter-events selected-partner  cursor-pointer"
                : "all-filter-events  cursor-pointer"
            }
          >
            <div
              className="group-box"
              onClick={() => setSelectedPartnerDetails("all")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M1.66666 33.3334V28.6667C1.66666 27.7222 1.90971 26.8542 2.39582 26.0625C2.88193 25.2709 3.52777 24.6667 4.33332 24.25C6.05555 23.3889 7.80555 22.7431 9.58332 22.3125C11.3611 21.882 13.1667 21.6667 15 21.6667C16.8333 21.6667 18.6389 21.882 20.4167 22.3125C22.1944 22.7431 23.9444 23.3889 25.6667 24.25C26.4722 24.6667 27.118 25.2709 27.6042 26.0625C28.0903 26.8542 28.3333 27.7222 28.3333 28.6667V33.3334H1.66666ZM31.6667 33.3334V28.3334C31.6667 27.1111 31.3264 25.9375 30.6458 24.8125C29.9653 23.6875 29 22.7222 27.75 21.9167C29.1667 22.0834 30.5 22.3681 31.75 22.7709C33 23.1736 34.1667 23.6667 35.25 24.25C36.25 24.8056 37.0139 25.4236 37.5417 26.1042C38.0694 26.7847 38.3333 27.5278 38.3333 28.3334V33.3334H31.6667ZM15 20C13.1667 20 11.5972 19.3472 10.2917 18.0417C8.9861 16.7361 8.33332 15.1667 8.33332 13.3334C8.33332 11.5 8.9861 9.93058 10.2917 8.62502C11.5972 7.31946 13.1667 6.66669 15 6.66669C16.8333 6.66669 18.4028 7.31946 19.7083 8.62502C21.0139 9.93058 21.6667 11.5 21.6667 13.3334C21.6667 15.1667 21.0139 16.7361 19.7083 18.0417C18.4028 19.3472 16.8333 20 15 20ZM31.6667 13.3334C31.6667 15.1667 31.0139 16.7361 29.7083 18.0417C28.4028 19.3472 26.8333 20 25 20C24.6944 20 24.3055 19.9653 23.8333 19.8959C23.3611 19.8264 22.9722 19.75 22.6667 19.6667C23.4167 18.7778 23.993 17.7917 24.3958 16.7084C24.7986 15.625 25 14.5 25 13.3334C25 12.1667 24.7986 11.0417 24.3958 9.95835C23.993 8.87502 23.4167 7.88891 22.6667 7.00002C23.0555 6.86113 23.4444 6.77085 23.8333 6.72919C24.2222 6.68752 24.6111 6.66669 25 6.66669C26.8333 6.66669 28.4028 7.31946 29.7083 8.62502C31.0139 9.93058 31.6667 11.5 31.6667 13.3334ZM4.99999 30H25V28.6667C25 28.3611 24.9236 28.0834 24.7708 27.8334C24.618 27.5834 24.4167 27.3889 24.1667 27.25C22.6667 26.5 21.1528 25.9375 19.625 25.5625C18.0972 25.1875 16.5555 25 15 25C13.4444 25 11.9028 25.1875 10.375 25.5625C8.84721 25.9375 7.33332 26.5 5.83332 27.25C5.58332 27.3889 5.38193 27.5834 5.22916 27.8334C5.07638 28.0834 4.99999 28.3611 4.99999 28.6667V30ZM15 16.6667C15.9167 16.6667 16.7014 16.3403 17.3542 15.6875C18.0069 15.0347 18.3333 14.25 18.3333 13.3334C18.3333 12.4167 18.0069 11.632 17.3542 10.9792C16.7014 10.3264 15.9167 10 15 10C14.0833 10 13.2986 10.3264 12.6458 10.9792C11.993 11.632 11.6667 12.4167 11.6667 13.3334C11.6667 14.25 11.993 15.0347 12.6458 15.6875C13.2986 16.3403 14.0833 16.6667 15 16.6667Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="group-name">
              {`All(${providersData.length})`}

              {selectedPartner === "all" ? (
                <span className="arrowdoen">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path d="M12 15L7 10H17L12 15Z" fill="#6941C6" />
                  </svg>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="slide-events-event">
          {isProviderLoaded ? (
            <>
              <Slider {...settings}>
                {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
                  <>
                    <div className="d-flex justify-content-center">
                      <ShimmerScreen
                        case="circle"
                        width="5.5rem"
                        height="5.5rem"
                      />
                    </div>
                    <div className="group-name">
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"0.7rem"}
                      />
                    </div>
                    <div className="group-name mt-1">
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"0.7rem"}
                      />
                    </div>
                  </>
                ))}
              </Slider>
            </>
          ) : (
            <Slider {...settings}>
              {_.isArray(providersData) && providersData.length > 0
                ? providersData.map((item) => (
                    <>
                      <div>
                        <div
                          className={
                            selectedPartner === item?.provider_id
                              ? "slide-box-filter selected-partner"
                              : "slide-box-filter"
                          }
                        >
                          <div
                            className="group-box"
                            style={{
                              backgroundImage: `url(${item.provider_img})`,
                            }}
                            onClick={() => setSelectedPartnerDetails(item)}
                          ></div>
                          {/* <div className="group-name">{item?.display_name}</div> */}
                          <div
                            className="group-name"
                            dangerouslySetInnerHTML={{
                              __html: item?.display_name,
                            }}
                          ></div>
                          {selectedPartner === item?.provider_id ? (
                            <span className="arrowdoen">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M12 15L7 10H17L12 15Z"
                                  fill="#6941C6"
                                />
                              </svg>
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                  ))
                : ""}
            </Slider>
          )}
        </div>
      </div>
      {_.isArray(providersData) &&
      providersData.length > 0 &&
      false &&
      selectedPartner != "all" ? (
        <div className="selected-partener-info">
          {isProviderLoaded ? (
            <ShimmerScreen case="rect" height="2rem" width="30rem" />
          ) : (
            <div className="partnerinfo-text">
              <strong>{selectedPartnerName}</strong> specialises in Coaching for
              Sales, Residential matters...
            </div>
          )}
          <div className="info-btn">
            {isProviderLoaded ? (
              <ShimmerScreen case="rect" height="3rem" width="10rem" />
            ) : (
              <button
                type="button"
                className="startcourse-btn colored-btn"
                onClick={() => detailPage()}
              >
                Know More
              </button>
            )}
          </div>
        </div>
      ) : (
        " "
      )}
    </>
  );
}

export default EventSliderFilterSection;
